import React from 'react'

const FilterPanel = () => {
    return (
        <div>
            
        </div>
    )
}

export default FilterPanel
